import { connect } from 'react-redux';
import { AppState } from '../app/app.types';
import { Member } from './members.types';
import MembershipAgreementComponent from './MembershipAgreementComponent';

type OwnProps = {
  member: Member
};

const mapDispatchToProps = (dispatch, ownProps: OwnProps) => {
  return {
    
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    businessState: state.businessState
  };
};

const MembershipAgreement: React.ComponentClass<OwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(MembershipAgreementComponent);

export default MembershipAgreement;



// WEBPACK FOOTER //
// ./src/members/MembershipAgreement.tsx